import React from 'react'

import { cn } from '@/lib/utils'

type Props = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode
}

const HelpText: React.FC<Props> = ({ className, style, children }) => (
  <div
    className={cn('text-muted-foreground! text-xxs', className)}
    style={{ marginTop: '2px', ...style }}
  >
    {children}
  </div>
)

export default HelpText
